import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Tema standard
import '../styles/ControlPanelStyle/QuillEditor.css';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Box } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
// using Box for layout; preview toggle will be a secondary-styled Button

import VisibilityIcon from '@mui/icons-material/Visibility';
import Alert from '@mui/material/Alert';
import PostTable from './BlogComponents/PostTable';
import EditPostModal from './BlogComponents/EditPostModal';

import ConnectionFinder from '../../api/ConnectionFinder';

const PostEditor = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [coverImage, setCoverImage] = useState('');
  const [status, setStatus] = useState('draft');
  const [viewMode, setViewMode] = useState(false);
  const [saving, setSaving] = useState(false);

  const [alert, setAlert] = useState();
  const [postList, setPostList] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  
  const quillRef = useRef(null);

  // Configurazione dei moduli di Quill (Toolbar)
  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        [{ 'color': [] }, { 'background': [] }], 
        ['link', 'image'],
        ['clean'],
      ],
      handlers: {
        image: function() {
          const range = this.quill.getSelection();
          const url = window.prompt("Inserisci l'URL dell'immagine remota:");
          
          if (url) {
            try {
              const parsedUrl = new URL(url);
              if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
                setAlert(<Alert severity="warning">Protocollo non sicuro. Usa http:// o https://</Alert>);
                return;
              }
              this.quill.insertEmbed(range ? range.index : 0, 'image', parsedUrl.toString());
            } catch (error) {
              setAlert(<Alert severity="error">URL non valido.</Alert>);
            }
          }
        }
      }
    }
  }), [setAlert]);

  const loadPostList = useCallback((currentPage = 0) => {
    ConnectionFinder.get(`/blog/listPost?page=${currentPage + 1}&limit=10`, {
      headers: {"x-access-token": localStorage.getItem('token')}
    }).then((res) => {
      setPostList(res.data.posts);
      setTotalItems(res.data.totalItems);
    });
  }, []);

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!title.trim()) {
      setAlert(<Alert severity="warning">Inserisci un titolo.</Alert>);
      return;
    }
    setSaving(true);
    try {
      await ConnectionFinder.post('/blog/publishPost', 
        { title, content, cover_image: coverImage, status },
        { headers: {
          "x-access-token": localStorage.getItem('token')
      }});
      setAlert(<Alert severity="success">Post creato con successo.</Alert>);
      setTitle('');
      setContent('');
      setCoverImage('');
      setStatus('draft');
      setPage(0);
      loadPostList(0);
      setViewMode(false);
    } catch (error) {
      console.error('Error creating post:', error);
      setAlert(<Alert severity="error">Errore nella creazione del post.</Alert>);
    } finally {
      setSaving(false);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    loadPostList(newPage);
  };

  const handleEditPost = (postId) => {
    setSelectedPostId(postId);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedPostId(null);
  };

  const handlePostSaved = () => {
    loadPostList(page);
  };

  const handleDeletePost = async (postId) => {
    if (window.confirm('Sei sicuro di voler eliminare questo post? L\'azione è irreversibile.')) {
        try {
            await ConnectionFinder.delete(`/blog/deletePost/${postId}`, {
                headers: { "x-access-token": localStorage.getItem('token') }
            });
            setAlert(<Alert severity="success">Post eliminato con successo.</Alert>);
            loadPostList(page); // Refresh the list
        } catch (error) {
            console.error('Error deleting post:', error);
            setAlert(<Alert severity="error">Errore durante l'eliminazione del post.</Alert>);
        }
    }
  };

  const handleVisibilityChange = async (postId, currentStatus) => {
    const newStatus = currentStatus === 'published' ? 'draft' : 'published';
    const actionText = newStatus === 'published' ? 'pubblicare' : 'spostare in bozza';

    if (window.confirm(`Sei sicuro di voler ${actionText} questo post?`)) {
        try {
            await ConnectionFinder.put(`/blog/updateStatus/${postId}`, 
                { status: newStatus },
                { headers: { "x-access-token": localStorage.getItem('token') } }
            );
            setAlert(<Alert severity="success">Visibilità del post aggiornata con successo.</Alert>);
            loadPostList(page); // Refresh the list
        } catch (error) {
            console.error('Error updating post status:', error);
            setAlert(<Alert severity="error">Errore durante l'aggiornamento della visibilità.</Alert>);
        }
    }
  };

  useEffect(() => {
    loadPostList(0);
  }, [loadPostList]);

  return (
    <>
    <div className="ImportContainer" style={{height: 'fit-content', paddingBottom: '10px', width: '90%'}}>
        <h1 style={{textAlign: 'left', marginLeft: '20px', color: '#5F6A6A',marginBottom: '0px'}}>Crea post</h1>
        {alert && <Box sx={{ width: '90%', margin: '10px auto' }}>{alert}</Box>}
        <form onSubmit={handleSubmit} style={{width: '90%',margin : 'auto'}}>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', marginBottom: '15px' }}>
              <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <input 
                  type="text" 
                  placeholder="Titolo Post"
                  value={title}
                  onChange={(e) => {setTitle(e.target.value); setAlert()}} 
                  className="cpInput" 
                  style={{width: '100%', height: '50px', marginLeft: '0', marginTop : '0'}}
                />  

                <input 
                  type="text" 
                  placeholder="URL Immagine di Copertina (es. https://esempio.it/immagine.jpg)"
                  value={coverImage}
                  onChange={(e) => setCoverImage(e.target.value)} 
                  className="cpInput" 
                  style={{width: '100%', height: '50px', marginLeft: '0', marginTop : '0'}}
                />  
              </Box>

              {coverImage && (
                <Box 
                  sx={{ 
                    width: '120px', 
                    height: '110px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    borderRadius: '8px', 
                    overflow: 'hidden', 
                    border: '1px solid #e0e0e0',
                    backgroundColor: '#fafafa',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    flexShrink: 0
                  }}
                >
                  <img 
                    src={coverImage} 
                    alt="Anteprima Copertina" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={(e) => { e.target.parentElement.style.display = 'none'; }}
                  />
                </Box>
              )}
            </Box>

            {viewMode ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Button
                  variant="outlined"
                  onClick={() => setViewMode(false)}
                  startIcon={<VisibilityIcon />}
                  sx={{
                    textTransform: 'none',
                    borderRadius: '8px',
                    color: '#5F6A6A',
                    backgroundColor: '#fafafa',
                    borderColor: '#e6e6e6',
                    '&:hover': { backgroundColor: '#f0f0f0', borderColor: '#ff0f64' },
                    alignSelf: 'flex-start',
                  }}
                >
                  Torna alla modifica
                </Button>

                <Box sx={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                  {coverImage && (
                    <Box sx={{ mb: 2, textAlign: 'center' }}>
                      <img 
                        src={coverImage} 
                        alt="Immagine di copertina" 
                        style={{ 
                          maxHeight: '300px', 
                          maxWidth: '100%', 
                          objectFit: 'cover', 
                          borderRadius: '8px',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                        }} 
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                    </Box>
                  )}
                  <h2 style={{ marginTop: 0, color: '#333' }}>{title}</h2>
                  <div
                    className="ql-editor"
                    style={{
                      marginTop: '20px',
                      padding: '15px',
                      backgroundColor: 'white',
                      borderRadius: '6px',
                      border: '1px solid #eaeaea',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                    }}
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                </Box>
              </Box>
            ) : (
              <>
                <div className='quillContainer'>
                  <ReactQuill 
                    ref={quillRef}
                    theme="snow"
                    value={content}
                    onChange={setContent}
                    modules={modules}
                    placeholder="Scrivi qui il tuo contenuto..."
                  />
                </div>

                <FormControl variant="outlined" sx={{ mt: 2, minWidth: 160, '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#ff0f64' } }, '& .MuiInputLabel-root.Mui-focused': { color: '#ff0f64' } }} size="small">
                  <InputLabel>Stato</InputLabel>
                  <Select
                    value={status}
                    label="Stato"
                    onChange={(e) => setStatus(e.target.value)}
                    disabled={saving}
                  >
                    <MenuItem value="draft">Bozza</MenuItem>
                    <MenuItem value="published">Pubblico</MenuItem>
                  </Select>
                </FormControl>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginTop: '12px' }}>
                  <Button
                    variant="outlined"
                    onClick={() => setViewMode(!viewMode)}
                    disabled={saving}
                    startIcon={!viewMode ? <VisibilityIcon /> : null}
                    sx={{
                        textTransform: 'none',
                        borderRadius: '8px',
                        color: '#5F6A6A',
                        backgroundColor: '#fafafa',
                        borderColor: '#e6e6e6',
                        '&:hover': { backgroundColor: '#f0f0f0', borderColor: '#ff0f64' },
                        alignSelf: 'flex-start',
                      }}
                  >
                    {viewMode ? 'Torna alla modifica' : 'Anteprima'}
                  </Button>

                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={saving}
                    sx={{
                      width: '200px',
                      marginTop: '5px',
                      borderRadius: '10px',
                      textTransform: 'none',
                      fontWeight: 'bold',
                      backgroundColor: '#ff0f64',
                      color: '#ffffff',
                      '&:hover': { backgroundColor: '#d10b52' },
                    }}
                  >
                    {saving ? 'Salvando...' : 'Salva'}
                  </Button>
                </Box>
              </>
            )}
        </form>
    </div>
    <div className="ImportContainer" style={{height: 'fit-content', marginTop: '30px', width: '90%'}}>
      <h1 style={{textAlign: 'left', marginLeft: '20px', color: '#5F6A6A',marginBottom: '0px'}}>Lista post</h1>
      <PostTable 
        rows={postList} 
        onEditClick={handleEditPost}
        onDeleteClick={handleDeletePost}
        onVisibilityChange={handleVisibilityChange}
        page={page}
        totalItems={totalItems}
        onPageChange={handlePageChange}
      />
    </div>

    <EditPostModal 
      open={editModalOpen}
      postId={selectedPostId}
      onClose={handleCloseEditModal}
      onSave={handlePostSaved}
    />
    </>
  );
};

export default PostEditor;